<div class="stat-tile">
  <div class="stat-tile__header">
    <span class="stat-tile__label">{{ stat.label }}</span>
    <span class="stat-tile__caption">{{ stat.caption }}</span>
  </div>

  <span class="stat-tile__value">{{ stat.value }}</span>

  @if (stat.trend !== 'flat') {
    <span class="stat-tile__delta" [class.stat-tile__delta--positive]="stat.isImprovement" [class.stat-tile__delta--negative]="!stat.isImprovement">
      {{ stat.trend === 'up' ? '↑' : '↓' }} {{ (stat.deltaPct < 0 ? -stat.deltaPct : stat.deltaPct) | number:'1.1-1' }}%
    </span>
  }

  <app-sparkline class="stat-tile__chart" [values]="stat.series" variant="blue"></app-sparkline>
</div>
